import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceAppService } from '../../../security/service-app.service';
import { IFiltros } from './interface-apuracao-vdm-acessorio';

export interface DadosPrincipaisResponse {
  dados: any[];
  totalBudgetFull: number;
  totalBudgetYtd: number;
  totalPendenteFull: number;
  totalPendenteYtd: number;
  totalRealizado: number;
  totalValorComDesconto: number;
  totalValorDesconto: number;
}

export interface DadosHistoricoResponse {
  dados: any[];
  filtroAno: number;
  totalAbrObjSpnv: number;
  totalAbrPercent: number;
  totalAbrSpnvRealizado: number;
  totalAbrVeiculosVista: number;
  totalAbrVendaAcessorio: number;
  totalMaiObjSpnv: number;
  totalMaiPercent: number;
  totalMaiSpnvRealizado: number;
  totalMaiVeiculosVista: number;
  totalMaiVendaAcessorio: number;
  totalJunObjSpnv: number;
  totalJunPercent: number;
  totalJunSpnvRealizado: number;
  totalJunVeiculosVista: number;
  totalJunVendaAcessorio: number;
  totalQ1ObjSpnv: number;
  totalQ1Percent: number;
  totalQ1SpnvRealizado: number;
  totalQ1VeiculosVista: number;
  totalQ1VendaAcessorio: number;
  totalJulObjSpnv: number;
  totalJulPercent: number;
  totalJulSpnvRealizado: number;
  totalJulVeiculosVista: number;
  totalJulVendaAcessorio: number;
  totalAgoObjSpnv: number;
  totalAgoPercent: number;
  totalAgoSpnvRealizado: number;
  totalAgoVeiculosVista: number;
  totalAgoVendaAcessorio: number;
  totalSetObjSpnv: number;
  totalSetPercent: number;
  totalSetSpnvRealizado: number;
  totalSetVeiculosVista: number;
  totalSetVendaAcessorio: number;
  totalQ2ObjSpnv: number;
  totalQ2Percent: number;
  totalQ2SpnvRealizado: number;
  totalQ2VeiculosVista: number;
  totalQ2VendaAcessorio: number;
  totalOutObjSpnv: number;
  totalOutPercent: number;
  totalOutSpnvRealizado: number;
  totalOutVeiculosVista: number;
  totalOutVendaAcessorio: number;
  totalNovObjSpnv: number;
  totalNovPercent: number;
  totalNovSpnvRealizado: number;
  totalNovVeiculosVista: number;
  totalNovVendaAcessorio: number;
  totalDezObjSpnv: number;
  totalDezPercent: number;
  totalDezSpnvRealizado: number;
  totalDezVeiculosVista: number;
  totalDezVendaAcessorio: number;
  totalQ3ObjSpnv: number;
  totalQ3Percent: number;
  totalQ3SpnvRealizado: number;
  totalQ3VeiculosVista: number;
  totalQ3VendaAcessorio: number;
  totalJanObjSpnv: number;
  totalJanPercent: number;
  totalJanSpnvRealizado: number;
  totalJanVeiculosVista: number;
  totalJanVendaAcessorio: number;
  totalFev2ObjSpnv: number;
  totalFevPercent: number;
  totalFevSpnvRealizado: number;
  totalFevVeiculosVista: number;
  totalFevVendaAcessorio: number;
  totalMarObjSpnv: number;
  totalMarPercent: number;
  totalMarSpnvRealizado: number;
  totalMarVeiculosVista: number;
  totalMarVendaAcessorio: number;
  totalQ4ObjSpnv: number;
  totalQ4Percent: number;
  totalQ4SpnvRealizado: number;
  totalQ4VeiculosVista: number;
  totalQ4VendaAcessorio: number;
}

@Injectable({
  providedIn: 'root'
})
export class ApuracaoVdmAcessorioService {

  constructor(private service: ServiceAppService) { }

  /**
   * Constrói a URL com os parâmetros corretos
   */
  private construirUrl(baseUrl: string, filtros: IFiltros, marca?: string): string {
    // Garante que os valores boolean sejam convertidos corretamente para string
    const selecaoVdmStr = filtros.selecaoVdm ? 'true' : 'false';
    const considerarBalcaoStr = filtros.considerarBalcao ? 'true' : 'false';
    
    let url = `${baseUrl}?dataAno=${filtros.dataAno}&selecaoVdm=${selecaoVdmStr}&considerarBalcao=${considerarBalcaoStr}`;
    if (marca) {
      url = `${baseUrl}?marca=${marca}&dataAno=${filtros.dataAno}&selecaoVdm=${selecaoVdmStr}&considerarBalcao=${considerarBalcaoStr}`;
    }
    
    return url;
  }

  /**
   * Busca os dados principais da apuração VDM
   */
  buscarDadosPrincipais(filtros: IFiltros): Observable<DadosPrincipaisResponse> {
    const url = this.construirUrl('/apuracao_vdm_acessorio/refat', filtros);
    return this.service.getDados(url);
  }

  /**
   * Busca os dados do histórico Jaguar
   */
  buscarDadosHistoricoJaguar(filtros: IFiltros): Observable<DadosHistoricoResponse> {
    const url = this.construirUrl('/apuracao_vdm_acessorio_historico_ref', filtros, 'jaguar');
    return this.service.getDados(url);
  }

  /**
   * Busca os dados do histórico Land Rover
   */
  buscarDadosHistoricoLandRover(filtros: IFiltros): Observable<DadosHistoricoResponse> {
    const url = this.construirUrl('/apuracao_vdm_acessorio_historico_ref', filtros, 'landRover');
    return this.service.getDados(url);
  }

  /**
   * Busca dados analíticos para download
   */
  buscarDadosAnaliticos(codDealer: string, filtros: IFiltros): Observable<any[]> {
    const url = `/apuracao_vdm_acessorio/refat/analitico?dealer=${codDealer}&dataAno=${filtros.dataAno}&selecaoVdm=${filtros.selecaoVdm}&considerarBalcao=${filtros.considerarBalcao}`;
    return this.service.downloadArquivo(url);
  }

  /**
   * Busca dados para exportação Excel - principais
   */
  buscarDadosParaExportacao(filtros: IFiltros): Observable<DadosPrincipaisResponse> {
    return this.buscarDadosPrincipais(filtros);
  }

  /**
   * Busca dados para exportação Excel - histórico Jaguar
   */
  buscarDadosParaExportacaoJaguar(filtros: IFiltros): Observable<DadosHistoricoResponse> {
    return this.buscarDadosHistoricoJaguar(filtros);
  }

  /**
   * Busca dados para exportação Excel - histórico Land Rover
   */
  buscarDadosParaExportacaoLandRover(filtros: IFiltros): Observable<DadosHistoricoResponse> {
    return this.buscarDadosHistoricoLandRover(filtros);
  }
}
